// extracted by mini-css-extract-plugin
module.exports = {"moreBtn":"MoreButton_moreBtn__SUgbO"};